// Dashboard
import { dashboardLists, dashboardListsConfig } from './dashboard.lists.js'

export default function dashboardListsRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(dashboardLists, dashboardListsConfig)
}
